import {Component} from '@angular/core';
import {AbstractDynamicFormFieldDirective} from './abstract-dynamic-form-field.directive';

@Component({
  selector: 'app-dff-select',
  templateUrl: './dff-select.component.html',
  styleUrls: ['./dff-select.component.scss']
})
export class DffSelectComponent extends AbstractDynamicFormFieldDirective {

  value = '';

  validate(value: string): string[] {
    return [];
  }

  writeValue(value: string) {
    this.value = value;
  }

  updateValue() {
    this.changeValue(this.value);
  }
}
